import React, { useState } from "react";
import Card from "./Card";

export default function Movies() {
  const [query, setQuery] = useState("");
  const [movies, setMovies] = useState([]);

  const searchMovies = async (event) => {
    event.preventDefault();
    const url = `https://api.themoviedb.org/3/search/movie?api_key=5dcf7f28a88be0edc01bbbde06f024ab&language=en-US&query=${query}&page=1`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      setMovies(data.results);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (event) => {
    setQuery(event.target.value);
  };

  return (
    <>
      <form action="#" className="form" onSubmit={searchMovies}>
        <label htmlFor="query" className="form-label">
          Movie Name
        </label>
        <input
          type="text"
          className="form-input"
          name="query"
          placeholder="i.e. Lord of the Rings"
          value={query}
          onChange={handleChange}
        />
        <button className="form-button">Search</button>
      </form>
      <div className="card-list">
        {movies
          .filter((movie) => movie.poster_path)
          .map((movie) => (
            <Card key={movie.id} movie={movie} />
          ))}
      </div>
    </>
  );
}
